import { render } from "./recipe-form.vue?vue&type=template&id=4b6cb643&scoped=true"
import script from "./recipe-form.vue?vue&type=script&lang=js"
export * from "./recipe-form.vue?vue&type=script&lang=js"

import "./recipe-form.vue?vue&type=style&index=0&id=4b6cb643&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6cb643"]])

export default __exports__